import {get} from './http';

// The What's new notes, served by the API behind sign-in rather than built into the bundle. Each is
// one file in src/PRI.Api/Data/WhatsNew/; how to write one is the whats-new skill.

export type WhatsNewNote = {
  readonly id: string;
  readonly date: string;
  readonly area: string;
  readonly title: string;
  readonly body: string;
  readonly where: string | null;
  readonly who: string | null;
  readonly how: string | null;
};

// The page's sections in page order, and this deployment's notes, newest first. The server leaves
// out the other platform's notes.
export type WhatsNewResponse = {
  readonly areas: readonly string[];
  readonly notes: readonly WhatsNewNote[];
};

export const whatsNewApi = {
  list: async () => get<WhatsNewResponse>('/whats-new')
};
